import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.293 19H20v2h-7v-6h2v3.198a6 6 0 10-3.874.739l-.288 1.98A8.001 8.001 0 0111 5.061V4h-1V2h4v2h-1v1.062A8.001 8.001 0 0117.293 19zM3 6.828L5.828 4l1.415 1.414-2.829 2.829L3 6.828zM18.414 4l2.829 2.828-1.415 1.415L17 5.414 18.414 4zm-3.878 5l1.414 1.414-3.536 3.536L11 12.536 14.536 9z"
    />
  </svg>
);
